<template lang="pug">
#history-snackbars
	UndoSnackbar(
		v-model="showAction"
		:timeout="8000"
		:header="displayedAction.header"
		:message="displayedAction.message"
		@undo="undoAction"
		@close="close"
	)
</template>

<script>
import { debounce } from 'debounce';
import UndoSnackbar from '@/components/UndoSnackbar';

export default {
  name       : 'history-snackbars',
  components : {
    UndoSnackbar
  },

  data() {
    return {
      showAction : false
    };
  },

  computed : {
    courseActionHistory() {
      return this.$store.getters.courseActionHistory;
    },

    // Simply returns the last action in courseActionHistory
    displayedAction() {
      const len = this.courseActionHistory.length;
      if ( len === 0 ) return {};
      return this.courseActionHistory[len - 1];
    }
  },

  created() {
    // We don't notify users when they undo an action
    // Since undoing actions can also append new actions, we need to wait for the store
    // to finalize a specific action history state.
    this.handleHistoryChange = debounce( this.handleHistoryChange, 100 );
  },

  watch : {
    courseActionHistory : {
      immdediate : true,
      handler( newHistory, oldHistory ) {
        this.handleHistoryChange( newHistory, oldHistory );
      }
    }
  },

  methods : {
    handleHistoryChange( newHistory, oldHistory ) {
      const oldLen = oldHistory.length;
      const newLen = newHistory.length;
      if ( newLen < oldLen ) return;

      this.showAction = true;
    },

    undoAction() {
      this.showAction = false;
      this.$store.dispatch( 'undoAction' );
    },

    close() {
      this.showAction = false;
    }
  }
};
</script>

<style lang="scss" scoped>
#history-snackbars {
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 10;
}
</style>
